import { render } from "./VisibleModal.vue?vue&type=template&id=4ee15f3a"
import script from "./VisibleModal.vue?vue&type=script&lang=js"
export * from "./VisibleModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__